module.exports = __webpack_public_path__ + "img/ic_shoppingcart_16.4e516e4e.svg";